import { createAction } from 'redux-actions';
import { PapiDeviation } from '@wix/da-types-papi';

export const PIN_POST_ON_FEED = 'PIN_POST_ON_FEED';

export type pinPostPayload = {
  item: PapiDeviation | undefined;
};

export const pinPostOnFeed = createAction<pinPostPayload>(PIN_POST_ON_FEED);
